import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import angleDown from '@fortawesome/fontawesome-free-solid/faAngleDown'

import '../css/FAQ.css'

class FAQ extends Component {
  constructor(props) {
    super(props);

    this.state = {
      questions : [
        { question: "DOES IT COST TO GET A BRA FITTING?", answer: "NO THERE IS NO CHARGE AND NO OBLIGATION TO PURCHASE." },
        { question: "DO YOU NEED AN APPOINTMENT FOR A BRA FITTING?", answer: "NO, BUT IF YOU HAVE SPECIAL NEEDS AND REQUIRE SPECIAL ATTENTION, IT IS ADVISABLE SO THAT WE ARE READY FOR YOU. " },
        { question: "HOW MUCH TIME DOES IT TAKE FOR A BRA FITTING?", answer: "THE MEASURING PORTION TAKE ABOUT 30 SECONDS AND THE AVERAGE FITTING TIME IS 10 TO 15 MINUTES." },
        { question: "WHAT ARE YOUR BUSINESS HOURS?", answer: "MONDAY-SATURDAY 10-5" },
        { question: "DO YOU TAKE APPOINTMENTS OUTSIDE OF YOUR BUSINESS HOURS?", answer: "YES PLEASE GIVE US A CALL TO BOOK 902-543-9100" },
        { question: "WHAT IS YOUR RANGE OF PRICES FOR BRAS?", answer: "OUR RANGE IS FROM $42.00 - $125.00" },
        { question: "IF I PLACE A SPECIALITY ORDER AM I OBLIGATED TO PURCHASE IT?", answer: "WE LOOK AT EACH INDIVIDUAL SPECIALITY ORDER AND DETERMINE HOW WE WILL PROCEED. IF WE RECOMMEND THAT YOU NEED A SIZE WE DO NOT HAVE THEN DEFINITELY YOU ARE NOT OBLIGATED TO BUY" },
        { question: "WHAT BRANDS DO YOU CARRY?", answer: "ELOMI, GODDESS, ANITA, AMOENA, FANTASIE, FREYA, CALVIN KLEIN, CHANTELLE, WARNERS, OLGA, SCULPTRESE, BLUSH, HANKY PANKY, PANACHE" },
        { question: "DO YOU HAVE SWIMSUITS?", answer: "YES" },
        { question: "DO YOU HAVE CHLORINE RESISTANT?", answer: "NO NOT AT THIS TIME, BUT ARE ABLE TO ORDER THEM IN. PLEASE LET US KNOW IF THIS IS SOMETHING YOU WOULD LIKE" },
        { question: "DO HAVE SPORTS BRAS?", answer: "YES" },
        { question: "WHAT TYPE OF WIGS DO YOU CARRY?", answer: "JON RENAU, EXPRESSIONS, REVLON, NORIKO, NEW IMAGE, LA VIE, RAQUEL WELSH AND GABOR?" },
        { question: "WHAT IS THE PRICE OF YOUR WIGS?", answer: "OUR RANGE IS FROM $100 - $500. WITH THE MAJORITY AROUND $200." },
        { question: "DO YOU CARRY HUMAN HAIR WIGS?", answer: "NO, HOWEVER WE ARE WILLING TO ORDER IN WITH A DEPOSIT. " },
        { question: "DO YOU ACCEPT RETURNS?", answer: " WE DO NOT ACCEPT RETURNS UNLESS IT IS A MERCHANDISE DEFECT." },
        { question: "HOW DO I CARE FOR MY LINGERIE?", answer: "WE RECOMMEND HANDWASHING AND CARRY A MILD DETERGENT CALLED EUCALAN THAT WILL ASSIST YOU IN CARING FOR ALL YOUR DELICATES." },
        { question: "HOW DO I CARE FOR MY WIG?", answer: "IT IS RECOMMENDED TO WASH YOUR SYNTHETIC WIG IN COLD WATER AND A MILD SHAMPOO FORMULATED FOR WIGS. " },
        { question: "DO I NEED TO MAKE AN APPOINTMENT TO BE FITTED WITH A BREAST PROSTHESIS?", answer: "YOU DO NOT HAVE TO MAKE AN APPOINTMENT, BUT WE DO RECOMMEND IT IF YOU ARE ABLE. " },
        { question: "HOW MUCH TIME SHOULD I ALLOW FOR A BREAST PROSTHESIS FITTING?", answer: "OUR FITTINGS ARE BETWEEN HALF HOUR AND AN HOUR.  " },
        { question: "DO YOU CARRY SLEEPWEAR?", answer: "YES. WE CARRY MANSFIELD AND NIKPAUL" },
        { question: "DO YOU CARRY MATERNITY?", answer: "YES, WE CARRY NURSING BRAS "}
      ]
    }
  }
  render() {
    return (
      <div>
        <div className="accordion" id="accordionExample">
        { this.state.questions.map(({ question, answer }, index) => (
          <div className="card" key={index}>
            <div className="card-header" id="headingOne">
              <h5 className="mb-0">
                <button className="btn" type="button" data-toggle="collapse" data-target={`#collapse${index}`} aria-expanded="true" aria-controls={`collapse${index}`}>
                  { question.toProperCase() } <FontAwesomeIcon icon={angleDown} size="sm"/>
                </button>
              </h5>
            </div>
            <div id={`collapse${index}`} className="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
              <div className="card-body">
                  { answer.toProperCase() }
                </div>
              </div>
          </div>
          ))}
        </div>
      </div>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/FAQ.jsx